import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showToast } from "./toastAction";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { uploadImages } from "../../utils/uploadFiles";

const addOurClient = (data, setLoading, history) => async (dispatch) => {
    setLoading && setLoading(true);
    let image;
    if (data.image) {
        image = await uploadImages([data.image]);
    }
    const payload = {
        title: data?.title,
        description: data?.description,
        author: {
            name: data?.name,
            role: data?.role,
            image: image ? image[0] : "",
        }
    };

    const res = await api("post", Constants.END_POINT.OUR_CLIENT, payload);
    if (res.success) {
        getOurClients(null);
        history.goBack();
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    setLoading && setLoading(false);
};

const getOurClients = (setLoading) => async (dispatch) => {
    if (setLoading) {
        setLoading(true);
    }
    const res = await api("get", Constants.END_POINT.OUR_CLIENTS);
    if (res.success) {
        if (res.data) {
            dispatch({
                type: types.OUR_CLIENTS,
                payload: res.data,
            });
        }
    }
    if (setLoading) {
        setLoading(false);
    }
};

const getOurClient = (id, returnData) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.END_POINT.OUR_CLIENT + `/${id}`);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            if (returnData) {
                returnData(res.data);
            }
        }
    }
    dispatch(hideLoaderAction());
};

const editOurClient = (id, data, setLoading, history) => async (dispatch) => {
    setLoading(true);
    let image;
    if (data.image) {
        image = await uploadImages([data.image]);
    }

    const payload = {
        title: data?.title,
        description: data?.description,
        author: {
            name: data?.name,
            role: data?.role,
            image: image ? image[0] : "",
        }
    };

    const res = await api("put", Constants.END_POINT.OUR_CLIENT + `/${id}`, payload);
    if (res.success) {
        getOurClients(null);
        history.goBack();
        dispatch(showToast({ severity: "success", summary: res.message }));
    }
    setLoading(false);
};

const deleteOurClient = (id) => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("delete", Constants.END_POINT.OUR_CLIENT + `/${id}`);
    if (res.success) {
        dispatch(getOurClients());
        dispatch(showToast({ severity: "success", summary: res.message }));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
    }
    dispatch(hideLoaderAction());
};

export { addOurClient, getOurClients, getOurClient, editOurClient, deleteOurClient };
